"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setMeasurement = setMeasurement;
exports.timedEventsToMeasurements = timedEventsToMeasurements;

var _debugBuild = require("../debug-build.js");

var _semanticAttributes = require("../semanticAttributes.js");

var _logger = require("../utils-hoist/logger.js");

var _spanUtils = require("../utils/spanUtils.js");

/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */
function setMeasurement(name, value, unit, activeSpan = (0, _spanUtils.getActiveSpan)()) {
  const rootSpan = activeSpan && (0, _spanUtils.getRootSpan)(activeSpan);

  if (rootSpan) {
    _debugBuild.DEBUG_BUILD && _logger.logger.log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
    rootSpan.addEvent(name, {
      [_semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE]: value,
      [_semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT]: unit
    });
  }
}
/**
 * Convert timed events to measurements.
 */


function timedEventsToMeasurements(events) {
  if (!events || events.length === 0) {
    return undefined;
  }

  const measurements = {};
  events.forEach(event => {
    const attributes = event.attributes || {};
    const unit = attributes[_semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_UNIT];
    const value = attributes[_semanticAttributes.SEMANTIC_ATTRIBUTE_SENTRY_MEASUREMENT_VALUE];

    if (typeof unit === 'string' && typeof value === 'number') {
      measurements[event.name] = {
        value,
        unit
      };
    }
  });
  return measurements;
}